import { useEffect } from 'react';

/**
 * Microsoft Clarity component for session recordings and heatmaps
 * Only loads on production domain
 */
export default function MicrosoftClarity() {
  useEffect(() => {
    const host = window.location.hostname.toLowerCase();
    if (host === 'trip147.com' || host === 'www.trip147.com') {
      (function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
      })(window, document, "clarity", "script", "v3w047y814");
    }
  }, []);

  return null;
}
